import { getRowStockState } from './stockHelper';

export const filterClaimRows = ({
  rows = [],
  claimStatus,
  processStatus,
  stockState,
  stockMap = {},
  selectedByItem = {},
}) =>
  (rows ?? []).filter((record) => {
    if (claimStatus && record.claimStatus !== claimStatus) return false;
    if (processStatus && record.processStatus !== processStatus) return false;
    if (!stockState) return true;
    return getRowStockState({ record, stockMap, selectedByItem }).state === stockState;
  });
